import {
  Award,
  BadgeCheck,
  BrainCircuit,
  Briefcase,
  Building2,
  ClipboardCheck,
  Cloud,
  GraduationCap,
  Handshake,
  Layers,
  LineChart,
  School,
  ShieldCheck,
  Sparkles,
  Target,
} from 'lucide-react';

export const services = [
  {
    id: 'ai-learning',
    Icon: GraduationCap,
    title: 'AI-Powered Learning Solutions',
    poweredBy: 'GATEtutor',
    description:
      'Deliver intelligent digital learning experiences through an integrated platform designed for students, educational institutions, and training organizations. GATEtutor combines learning, assessments, coding practice, analytics, and career readiness into one unified ecosystem.',
    features: [
      'Learning Management System',
      'Digital Classroom',
      'Coding Assessments',
      'Smart Practice Engine',
      'Performance Analytics',
      'Career Readiness Platform',
    ],
    cta: 'Explore GATEtutor',
    link: 'https://gatetutor.in',
    external: true,
    accent: 'brand',
  },
  {
    id: 'ai-analytics',
    Icon: BrainCircuit,
    title: 'AI Intelligence & Analytics',
    poweredBy: 'PragyaAI',
    description:
      'Harness the power of Artificial Intelligence to deliver intelligent recommendations, predictive analytics, personalized learning experiences, and actionable insights. PragyaAI transforms educational and enterprise data into measurable intelligence.',
    features: [
      'AI Recommendation Engine',
      'Learning Analytics',
      'Predictive Intelligence',
      'Personalized Learning',
      'Institutional Analytics',
      'Data-Driven Decision Making',
    ],
    cta: 'Explore PragyaAI',
    link: '/products',
    external: false,
    accent: 'indigo',
  },
  {
    id: 'apex',
    Icon: Target,
    title: 'AI Productivity & Excellence Assessment',
    poweredBy: 'APEX',
    description:
      "APEX is Microsage's AI Productivity & Excellence Platform designed to measure real-world AI productivity, professional competencies, and employability readiness. It provides standardized benchmarking for students, institutions, and employers through data-driven intelligence.",
    features: [
      'AI Productivity Benchmark',
      'Competency Assessment',
      'Employability Intelligence',
      'Outcome-Based Evaluation',
      'Workforce Readiness Analytics',
      'Institutional Benchmarking',
    ],
    cta: 'Explore APEX',
    link: '/contact',
    external: false,
    accent: 'emerald',
  },
  {
    id: 'campus-hiring',
    Icon: Briefcase,
    title: 'Campus Hiring & Employability Solutions',
    description:
      'Bridge the gap between education and industry through intelligent hiring solutions that connect students, institutions, and employers using AI-driven talent discovery and employability intelligence.',
    features: [
      'Campus Recruitment',
      'Internship Management',
      'Resume Screening',
      'Talent Discovery',
      'Employer Dashboard',
      'Placement Analytics',
    ],
    cta: 'Learn More',
    link: '/contact',
    external: false,
    accent: 'sky',
  },
  {
    id: 'enterprise',
    Icon: Building2,
    title: 'Enterprise Digital Transformation',
    description:
      'Accelerate business growth through intelligent enterprise software, automation, AI integration, cloud solutions, and scalable digital transformation services tailored for modern organizations.',
    features: [
      'Enterprise Software',
      'Custom Web Applications',
      'Mobile Applications',
      'AI Integration',
      'Cloud Solutions',
      'Business Process Automation',
    ],
    cta: 'Learn More',
    link: '/contact',
    external: false,
    accent: 'brand',
  },
  {
    id: 'institutions',
    Icon: School,
    title: 'Educational Institution Solutions',
    description:
      'Empower schools, colleges, universities, and training organizations with intelligent digital infrastructure that improves academic outcomes, administration, and institutional performance.',
    features: [
      'Institution ERP',
      'Academic Analytics',
      'Faculty Management',
      'Student Lifecycle Management',
      'Outcome-Based Education',
      'Accreditation Support',
    ],
    cta: 'Learn More',
    link: '/contact',
    external: false,
    accent: 'indigo',
  },
  {
    id: 'assessment',
    Icon: ClipboardCheck,
    title: 'Assessment & Examination Solutions',
    description:
      'Deliver secure, scalable, and intelligent examination systems with AI-powered assessment, coding evaluations, proctoring, analytics, and certification management.',
    features: [
      'Online Assessments',
      'Coding Tests',
      'AI Evaluation',
      'Secure Proctoring',
      'Digital Certificates',
      'Assessment Analytics',
    ],
    cta: 'Learn More',
    link: '/contact',
    external: false,
    accent: 'emerald',
  },
  {
    id: 'consulting',
    Icon: Handshake,
    title: 'Consulting & Implementation Services',
    description:
      'Support organizations throughout their digital transformation journey with technology consulting, implementation, AI adoption strategies, onboarding, training, and long-term technical support.',
    features: [
      'Technology Consulting',
      'Digital Transformation Strategy',
      'AI Adoption Consulting',
      'Product Implementation',
      'User Training',
      'Technical Support',
    ],
    cta: 'Learn More',
    link: '/contact',
    external: false,
    accent: 'sky',
  },
];

export const whyChoose = [
  { id: 'ai-innovation', Icon: Sparkles, title: 'AI-Powered Innovation' },
  { id: 'ecosystem', Icon: Layers, title: 'Integrated Technology Ecosystem' },
  { id: 'cloud', Icon: Cloud, title: 'Scalable Cloud Solutions' },
  { id: 'secure', Icon: ShieldCheck, title: 'Secure & Reliable Platforms' },
  { id: 'outcomes', Icon: LineChart, title: 'Outcome-Based Intelligence' },
  { id: 'industry', Icon: Target, title: 'Industry-Aligned Solutions' },
  { id: 'startup-india', Icon: BadgeCheck, title: 'Startup India Recognized' },
  { id: 'msme', Icon: Award, title: 'MSME Registered' },
];
